(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-description-tab"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  function productdesciptiontab() { 
  const button_tabs = document.querySelectorAll(".product-tab_title-label");  
  if (!button_tabs.length) return; 
    button_tabs.forEach(function (tabs) {
    tabs.addEventListener("click", function () { 
      const wrapper = document.querySelector(".product-tab-content");  
      const tab_content = wrapper.querySelectorAll(".product-description-tab-content"); 
      const target_id = this.getAttribute("data-title"); 
      button_tabs.forEach(item => item.classList.remove("is-active"));
      this.classList.add("is-active");  
      tab_content.forEach(item => item.classList.remove("is-active"));
      wrapper.querySelector('#'+target_id).classList.add("is-active");  
    });
  }); 
 
  } 
  productdesciptiontab();
 
   const jdgmreview = document.querySelector(".product-details .jdgm-widget.jdgm-preview-badge"); 
  if (!jdgmreview) return; 
    jdgmreview.addEventListener("click", function () { 
    const reviewtab = document.querySelector('.product-tab_title-label[data-title="desctab-reviews"]');
    reviewtab?.scrollIntoView({ behavior: "smooth", block: "start" });
    (reviewtab instanceof HTMLElement) && reviewtab.click();
  }); 

 });
  } catch(e) { console.error(e); }
})();

})();
